import { create } from 'zustand'

type TrialBannerStoreState = {
  trialBannerHeight: number
  setTrialBannerHeight: (height: number) => void
}

const useTrialBannerStore = create<TrialBannerStoreState>(set => ({
  trialBannerHeight: 0,
  setTrialBannerHeight: (height: number) => set({ trialBannerHeight: height }),
}))

export default useTrialBannerStore

export const useTrialBannerHeight = () => {
  const trialBannerHeight = useTrialBannerStore(state => state.trialBannerHeight)
  const setTrialBannerHeight = useTrialBannerStore(state => state.setTrialBannerHeight)

  return {
    trialBannerHeight,
    setTrialBannerHeight,
  }
}
